import {
  Navigate,
  Outlet,
  useParams,
  useRouteLoaderData,
} from '@rocketlane/rocket-router';
import styled from 'styled-components';
import { ProjectResourceOrUndefined } from 'hooks/rbac/useWithAccess';
import { SwitchContentBasedOnAccess } from 'hooks/rbac/withAccess';
import { getProjectPlanUrl, getProjectTasksUrl } from 'utils/urls';
import type { projectDetailLoader } from './data-loaders';
import { RouteIds } from './routes-paths';

export const Fallback = () => {
  // eslint-disable-next-line @calm/react-intl/missing-formatted-message
  return <p>Performing initial data load</p>;
};

/** Renders auth routes above `#rl-boot-skeleton` (z-index 9999) without dismissing it. */
const AuthRoutesLayer = styled.div`
  position: relative;
  z-index: 10000;
  min-height: 100vh;
  min-height: 100dvh;
`;

export const NonProtectedRoutesLayout = () => {
  return (
    <AuthRoutesLayer>
      <Outlet />
    </AuthRoutesLayer>
  );
};

export const ProjectDetailRouteNavigator = () => {
  const { projectId: _projectId } = useParams<any>();
  const projectData = useRouteLoaderData(
    RouteIds.projectDetailRoute,
  ) as Awaited<ReturnType<ReturnType<typeof projectDetailLoader>>>;

  const projectAsResource = ProjectResourceOrUndefined(projectData);

  return (
    <>
      <SwitchContentBasedOnAccess
        rule="PROJECT:READ"
        resourceData={projectAsResource}
        hasAccess={
          <Navigate
            replace
            to={getProjectPlanUrl([
              'project_id',
              Number(projectData?.projectId),
            ])}
          />
        }
        doesNotHaveAccess={
          <Navigate
            replace
            to={getProjectTasksUrl([
              'project_id',
              Number(projectData?.projectId),
            ])}
          />
        }
      />
    </>
  );
};

export const DashboardWidgetWrapper = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
